import { FC, useCallback, useEffect, useMemo, useRef } from "react";
import Button from "Components/UI/Button";
import { Icon } from "Components/UI";
import FilterDropdown from "./components/FilterDropdown";
import { IUpdateFilter } from "Data/interfaces/Notification/IFilters";
import { FiltersRecordType } from "Data/interfaces/Notification/IFilters";
import { isObjectEmpty } from "Utils/ObjectUtils";
import { Container } from "./styles";

interface IFilters {
  filters: FiltersRecordType;
  lastFilterUpdateId: string;
  firstOpenFilters: boolean;
  blockFilterDropdown: boolean;
  addFilter: () => void;
  updateFilter: (values: IUpdateFilter) => void;
  deleteFilter: (filterId: string) => void;
}

const Filters: FC<IFilters> = ({
  filters,
  lastFilterUpdateId,
  firstOpenFilters,
  blockFilterDropdown,
  addFilter,
  updateFilter,
  deleteFilter,
}) => {
  const filterContainerRef = useRef<HTMLDivElement | null>(null);

  const filtersArray = useMemo(() => {
    if (filters && !isObjectEmpty(filters)) {
      return Object.keys(filters);
    }
    return [];
  }, [filters]);

  const filtersLength = filtersArray.length;
  const haveFilters = filtersLength > 0;

  const scrollNow = useCallback(() => {
    if (filterContainerRef.current) {
      filterContainerRef.current.scrollLeft = filterContainerRef.current.scrollWidth;
    }
  }, []);

  const handleAddFilter = () => {
    addFilter();
    scrollNow();
  }

  useEffect(() => {
    if (filtersArray[filtersLength - 1] === lastFilterUpdateId) {
      scrollNow();
    }
  }, [filters, filtersArray, filtersLength, lastFilterUpdateId, scrollNow]);

  return (
    <Container ref={filterContainerRef}>
      {haveFilters && filtersArray.map((id: string) => {
        const currentObj = filters[id];

        return (
          <FilterDropdown
            key={id}
            id={id}
            item={currentObj}
            firstOpenFilters={firstOpenFilters}
            blockFilterDropdown={blockFilterDropdown}
            updateFilter={updateFilter}
            deleteFilter={deleteFilter}
          />
        )
      })}
      {!haveFilters && (
        <Button
          type="text"
          className="moreFilterButton"
          onClick={handleAddFilter}
        >
          <Icon
            icon="adicionar"
            color="cinzaEscuro"
            customSize={14}
            className="buttonIcon"
          />
          <span className="buttonText">Adicionar Filtro</span>
        </Button>
      )}
      {haveFilters && (
        <Button
          type="text"
          className="moreFilterButton moreFilterButtonMore"
          onClick={handleAddFilter}
        >
          <Icon
            icon="adicionar"
            color="cinzaEscuro"
            customSize={14}
            className="buttonIcon"
          />
        </Button>
      )}
    </Container>
  )
}

export default Filters;
